import React, { useState } from "react";
import password from "../../Images/password.webp";
import PasswordInput from "../PasswordReset/PasswordInput";
import EmailEnter from "../PasswordReset/EmailEnter";
import { Empty } from "antd";
import { FaAngleLeft } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import "../account/ForgotPassword.css";

export default function ForgotPassword() {
  const [otpSubmit, setOtpSubmit] = useState(false);
  const [remberToken, setRememberToken] = useState(null);
  const [otpData, setOtpData] = useState("")
  const [userEmail,setUserEmail] = useState("")
  return (
    <div className="container forgotePassword">
      <div className="row w-100">
        <div className="col-md-6 d-flex align-items-center justify-content-center flex-column">
          {otpSubmit ? (
            otpData ? (
              <PasswordInput  otpData={otpData} userEmail={userEmail}/>
            ) : (
              <>
                {" "}
                <Empty />
                <h4>Email Id is not registred !</h4>
                <NavLink to="/account/sign-in">
                  <FaAngleLeft /> Back to login page
                </NavLink>
              </>
            )
          ) : (
            <EmailEnter
              setOtpSubmit={setOtpSubmit}
              setRememberToken={setRememberToken}
              setOtpData={setOtpData}
              setUserEmail={setUserEmail}
            />
          )}
        </div>
        <div className="col-md-6 d-flex align-items-center justify-content-center">
          <div className="imageDiv">
            <img src={password} />
          </div>
        </div>
      </div>
    </div>
  );
}
